import React, { Component } from 'react';
import logo from '../../img/title.svg';
import search from '../../img/search.svg';
import cart from '../../img/cart.svg';
import alarm from '../../img/alarm.svg';
import before from '../../img/before.svg';
import Big3Common from "../../js/Big3Common";

import { Link } from 'react-router-dom';
/* 개발담당:양유빈
 * 화면기능:풋터 공통 컴포넌트
 * 세부설명:헤더메인 페이지, 
 * 아이콘기: 클로디 로고,검색버튼 아이콘, 카트 아이콘, 알림 아이콘 
*/
export class HeaderMain extends Component {
    static displayName = HeaderMain.name;

    constructor(props) {
        super(props);
        this.state = {
            AlarmCount: 0,
            BasketCount:0
        };
        Big3Common.Authentication(this);
    }
    //초기화
    async componentDidMount() {
        try {
            let data = await Big3Common.Get("api/Common/Common/GetAllmMgtBasketCount");
            if (data.codeName === Big3Common.ResultCode.Success) {
                let Data = JSON.parse(data.multiDataTable);
                this.setState({ AlarmCount: parseInt(Data.Alarm), BasketCount: parseInt(Data.Basket) }); 
            }
        }
        catch (e) {
            console.log("componentDidMount: ", e)
        }
    }
    //추가헤더 링크--> 헤더 아래에 뒤로가기 버튼이 있음
    subrenderLink() {
        if (this.props.HeaderSub.LinkYn === "N") {
            if (this.props.HeaderSub.ComponentUrl === "") {
              
                return (
                    <Link to={-1}>
                        <img src={before} alt="이전화면" />
                    </Link>
                )
            }
            else {
                return (
                    <div onClick={() => this.props.RenderComponent(this.props.HeaderSub.ComponentUrl)} style={{ cursor: 'pointer' }}>
                        <img src={before} alt="이전화면" />
                    </div>
                )
            }
        }
        else {
            return (
                <Link to={this.props.HeaderSub.LinkUrl}>
                    <img src={before} alt="이전화면" />
                </Link>
             )
        }
    }
    //추가헤더
    //설명: 메인헤더 아래에 링크 및 타이틀 기능
    //HeaderSub={{ Title: "찜한매장", LinkYn: "N", LinkUrl: "", ComponentName: "BoorkMarkGoods" }}
    subrender() {
        if (this.props.HeaderSub === undefined || this.props.HeaderSub === null) {
            return ("");
        }
        else {
            let subrenderLink = this.subrenderLink();
            return (
                <div className="nav">
                    <div className="before">
                        {subrenderLink }
                    </div>
                    <div className="page_title">
                        {this.props.HeaderSub.Title }
                    </div>
                    <div className="hide"></div>
                </div>
            )
        }
        
    }
    render() {
        let subrender = this.subrender();
        return (
            <header>
                <div className="main_title">
                    <div className="main_logo">
                        <Link to="/">
                            <img src={logo} alt="logo" />
                        </Link>
                    </div>
                    <div className="header_icon_box">
                        {/*<div className="main_alarm">*/}
                        {/*    <Link to="/Search/Similar/SimilarGoods">*/}
                        {/*        <img src={img_search} alt="이미지검색" style={{ width:"28px" }} />*/}
                        {/*    </Link>*/}
                        {/*</div>*/}
                        <div className="main_alarm">
                            <Link to="/Search/Goods/Index">
                                <img src={search} alt="검색아이콘" />
                            </Link>
                        </div>
                        <div className="main_alarm">
                            <Link to="/MyPage/Basket/Index">
                                <img src={cart} alt="카트아이콘" />
                                <span><b>{this.state.BasketCount}</b></span>
                            </Link>
                        </div>
                        <div className="main_alarm">
                            <Link to="/MyPage/Notice/Index">
                                <img src={alarm} alt="공지알람아이콘" />
                                <span><b>{this.state.AlarmCount}</b></span>
                            </Link>
                        </div>
                    </div>
                </div>
                {subrender}
            </header>
        );
    }
}
